import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class DistanceService {
  private readonly apiKey = environment.openStreetMapApiKey;
  private url = 'https://api.openrouteservice.org/v2/directions/driving-car';

  constructor(private readonly http: HttpClient) {
  }

  getDistance(from: [number, number], to: [number, number]) {
    this.url = `https://api.openrouteservice.org/v2/directions/driving-car?api_key=${environment.openStreetMapApiKey}&start=${from[1]},${from[0]}&end=${to[0]},${to[1]}`;

    return this.http.get<any>(this.url, {
      headers: {
        Authorization: this.apiKey,
        'Content-Type': 'application/json',
      },
    });
  }

}
